<script lang="ts">
import { RefOrdersComponent } from "./ref-orders.ts";
export default RefOrdersComponent;
</script>

<template>
    <div v-for="order in orders" v-bind:key="order.id" class="ref-orders-list-item">
        <div class="ref-order p-d-flex p-ai-center">
            <img
                class="ref-order-images"
                v-app-fast-gallery="{ images: images(order) }"
            />
            <div class="ref-order-details">
                <div class="ref-order-title">
                    {{ order.title }}
                </div>
                <div class="ref-order-description">
                    <div v-for="(desc, index) in order.description" :key="index">
                        {{ desc }}
                    </div>
                </div>
                <div class="ref-order-price">
                    <strong class="text-right">
                        <app-format-currency
                            v-if="!isOrderWithTBD(order)"
                            :value="order?.total_price"
                            :currency="order?.currency"
                        ></app-format-currency>
                        <template v-else>TBD</template>
                    </strong>
                </div>
            </div>
        </div>
        <p-divider class="p-m-0" />
    </div>
</template>
